var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRulerOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.292 16.293a1 1 0 000 1.414l5 5a1 1 0 001.414 0l15-15a1 1 0 000-1.414l-5-5a1 1 0 00-1.414 0l-15 15zM7 20.586L3.413 17 5 15.414l.293.293a1 1 0 001.414-1.414L6.414 14 8 12.414l1.293 1.293a1 1 0 001.414-1.414L9.414 11 11 9.414l.293.293a1 1 0 001.414-1.414L12.414 8 14 6.414l1.293 1.293a1 1 0 101.414-1.414L15.414 5l1.585-1.585L20.585 7 6.999 20.586z"
  })));
}
export default SvgRulerOutline;